import React, { useRef, useState, useContext } from 'react';
import useIntersectionObserver from '../../../hooks/useIntersectionObserver';
import '../../../style.css';

const Bigscreen = ({ slug }) => {
    const sectionRef = useRef(null);
    const [contentLoaded, setContentLoaded] = useState(false);

    const handleIntersection = () => {
        setContentLoaded(true);
    };

    const isVisible = useIntersectionObserver(sectionRef, handleIntersection);

    return (
        <div ref={sectionRef} className={`loading-container${contentLoaded ? '' : ' loading-spinner-container'}`}>
            {contentLoaded ? (
                <section className={`bigscreen${isVisible ? ' fade-in-observer' : ''}`} id="bigscreen">
                    <div className="bigscreen">
                        <div className="image">
                            <img src={`/assets/images/portfolio/bigscreen/bigscreen-${slug}.png`} alt="Several image captures showcasing the product UI" />
                        </div>
                    </div>
                </section>
            ) : (
                <div className="observer_spinner"></div>
            )}
        </div>
    );
};

export default Bigscreen;
